import { H as u } from "./localisationConfig-BfnSuGmH.js";
import { f as x, a as y, g as D, b as v, s as N } from "./localisationConfig-BfnSuGmH.js";
import { e as I, a as L, g as V, c as E, i as T, d as W, b as H, n as M, r as k, s as J, h as O, f as P, t as $ } from "./i18n-DoHK2p36.js";
import { c as A, f as B } from "./react-COm4a01v.js";
import { e as G, c as j, b as q, a as K, i as Q } from "./typePredicates-CHcjxMc5.js";
import { c as X } from "./tailwind-BXrsiEcF.js";
function d(t) {
  return u.parseWithoutProcessing(t).body.filter(({ type: o }) => o === "MustacheStatement").map((o) => {
    var r;
    const a = o, n = a.params, s = a.path;
    return ((r = n[0]) == null ? void 0 : r.original) || s.original;
  });
}
const f = {};
let p = 0;
function c(t, e) {
  const o = `atom${++p}`, a = {
    toString() {
      return (f ? "demo" : void 0) !== "production" && this.debugLabel ? o + ":" + this.debugLabel : o;
    }
  };
  return typeof t == "function" ? a.read = t : (a.init = t, a.read = l, a.write = m), e && (a.write = e), a;
}
function l(t) {
  return t(this);
}
function m(t, e, o) {
  return e(
    this,
    typeof o == "function" ? o(t(this)) : o
  );
}
function b(t, e) {
  const a = c((() => {
    const n = localStorage.getItem(t);
    return n !== null ? JSON.parse(n) : e;
  })());
  return c(
    (n) => n(a),
    (n, s, r) => {
      const i = typeof r == "function" ? r(n(a)) : r;
      s(a, i), localStorage.setItem(t, JSON.stringify(i));
    }
  );
}
function h(t) {
  t != null && t.raw_output && (t.raw_output = t.raw_output.replace(/^<.*>\n/, ""), t.raw_output = t.raw_output.replace(
    /\n?<\/.*>$/,
    ""
  ));
}
function _(t) {
  const e = { ...t };
  return e.results = e.parsed_output, e;
}
export {
  b as atomWithLocalStorage,
  X as cn,
  A as createMDWrapper,
  G as extractVersionInfo,
  B as fixedForwardRef,
  x as formatDate,
  y as formatTime,
  D as getDateDifference,
  d as getHandlebarsVariables,
  I as getLanguageName,
  v as getLocalisationEntry,
  L as getText,
  V as getTextNoop,
  E as interpolate,
  T as interpolateNoop,
  W as interpolateString,
  j as isConversationDone,
  q as isConversationDraft,
  K as isConversationInProgress,
  Q as isVersionedReviewData,
  H as nGetText,
  M as ngettext,
  _ as parseExpertResult,
  k as renderTemplateString,
  h as sanitizeExpertResults,
  J as sentenceCase,
  N as sortByDate,
  O as stripMarkdown,
  P as titleCase,
  $ as translateNoop
};
//# sourceMappingURL=lib.js.map
